export default __webpack_public_path__ + "static/media/_DSC0790.194e7df6.JPG";